import Button from '@doordash/component-button'
import Logo from '@doordash/component-logo'
import {
  Breakpoints,
  Colors,
  Inset,
  Media,
  Spacing,
} from '@doordash/design-language'
import styled from 'styled-components'
import { SimpleStyleType } from '../../templates/simple/constants'
import { HEADER_HEIGHT_PX } from '../../pages/detail-signup/constants'

type HeaderProps = {
  isScrolled?: boolean
  hideWhenMobile: boolean
  experiment?: boolean
  type?: SimpleStyleType
  isDark?: boolean
  showLogoText?: boolean
  isTransparent?: boolean
}

export const DoorDashLogoContainer = styled.div`
  padding-left: ${Spacing.Medium}px;
`

export const DoorDashLogo = styled(Logo).attrs<{}>({
  color: (props: HeaderProps) =>
    props.isDark ? Logo.Colors.White : Logo.Colors.Red,
  type: (props: HeaderProps) =>
    props.showLogoText ? Logo.Types.Logo : Logo.Types.LogoMark,
})``

export const InsetContainer = styled(Inset)`
  width: 100%;
`

export const HeaderStyle = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 2;
  transition: 0.3s ease-in-out all;
  background: ${(props: HeaderProps) =>
    props.isTransparent ? 'none' : 'rgba(255, 255, 255, 0.95)'};
  background-color: none;
  border-bottom: ${(props: HeaderProps) =>
    props.isTransparent ? 'none' : `1px solid ${Colors.BorderSecondary}`};
  height: ${HEADER_HEIGHT_PX}px;

  ${Media.Mobile`
    ${(props: HeaderProps) =>
      props.experiment &&
      props.type === SimpleStyleType.Landing &&
      `
          position: fixed;
      `}

    ${(props: HeaderProps) =>
      props.experiment && props.type === SimpleStyleType.Landing && props.isDark
        ? `
          background: ${Colors.SystemRed5};
          border-bottom: 1px solid transparent;
        `
        : `
          background: ${Colors.SystemWhite};
      `}
  `}

  ${(props: HeaderProps) =>
    props.isScrolled &&
    `
     border-bottom: 1px solid #ddd;
     background: white;
  `};
  ${(props: HeaderProps) =>
    props.hideWhenMobile &&
    `
      @media (max-width: 480px) {
        display: none;
      }
  `}
`

export const MobileLogo = styled.span`
  display: none;
  @media (max-width: ${Breakpoints.Mobile}px) {
    display: block;
  }
`

export const DesktopLogo = styled.span`
  display: none;
  @media (min-width: ${Breakpoints.Mobile + 1}px) {
    display: block;
  }
`

export const LoginButton = styled(Button).attrs<{}>({
  type: Button.Types.SecondaryPill,
  isInline: true,
})``

export default HeaderStyle
